module.exports = __webpack_public_path__ + "static/img/8.a7e8670.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/8.png
// module id = n0NP
// module chunks = 0